<template>
    <div class="number-change">
        <span class="label abs">数量：</span>
        <el-select v-model="value" placeholder="请选择" popper-class="number-change-popper" @change="change(value,id)">
            <el-option
                    v-for="item in items"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<style lang="scss" type="text/scss" >
    .number-change{
        .el-select{
            .el-input__inner{
                width: 200px;
                border: none;
                border-radius: 0;
                @include SourceHanSerifSC-bold;
                font-size: 16px;
                padding-left: 50px;
            }
            .el-select__caret{
                color: #8F8F8F;
            }
        }
    }
    .number-change-popper{
        .el-select-dropdown__list{
            padding: 0;
        }
        .el-select-dropdown__item{
            padding: 0 30px;
            @include SourceHanSerifSC-bold;
            &:hover{
                background-color: $primary-color;
                color: #fff;
            }
            &.selected{
                color: $primary-color;
                &.hover{
                    color: #fff;
                }
                &:hover{
                    background-color: $primary-color;
                    color: #fff;
                }
            }
        }
    }
</style>
<style lang="scss" type="text/scss" scoped>
    .number-change{
        border-bottom: 1px solid #f5f5f5;
        position: relative;
        .label{
            @include SourceHanSerifSC-bold;
            font-size: 16px;
            z-index: 11;
            line-height: 40px;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                value:this.selectedValue
            }
        },
        watch:{
            selectedValue(val){
                this.value = val
            }
        },
        props:{
            items:{
                type:Array,
                default:[]
            },
            selectedValue:{
                type:[String,Number],
                default:''
            },
            change:{
                type:Function,
                default(){
                    return ()=>{

                    }
                }
            },
            id:{
                type:[String,Number],
                default:''
            }
        }
    }
</script>